new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    }
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const brands = document.querySelector('#brands-carousel');
    if(brands) {
        $('#brands-carousel').slick({
            arrows: false,
            dots: true,
            infinite: false,
            autoplay: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
            ]
        });
    }

    waitForElementToExist('#product_list').then(element => {
        $('#product_list').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-3').then(element => {
        $('#product_list-3').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-4').then(element => {
        $('#product_list-4').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-2').then(element => {
        $('#product_list-2').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-7').then(element => {
        $('#product_list-7').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-8').then(element => {
        $('#product_list-8').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-9').then(element => {
        $('#product_list-9').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-10').then(element => {
        $('#product_list-10').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#product_list-11').then(element => {
        $('#product_list-11').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.home-product__list.last').then(element => {
        let rotationShowcase = document.querySelector('.home-product__list.last');
        if (rotationShowcase) {
            let rotationShowcaseNames = rotationShowcase.querySelectorAll('.content-text h3');
            let initShowcase = rotationShowcase.querySelectorAll('.product_list.last ');
            initShowcase = Array.from(initShowcase);
        
            if(rotationShowcase && rotationShowcaseNames.length && initShowcase.length) {
                initShowcase[0].classList.add('active');
                rotationShowcaseNames[0].classList.add('active');
        
                function activeTab(index) {
                    initShowcase.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationShowcaseNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initShowcase[index].classList.add('active');
                    rotationShowcaseNames[index].classList.add('active');
    
                    $('#product_list-5').slick('refresh');
                    $('#product_list-6').slick('refresh');
                }
        
                rotationShowcaseNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }

            $('#product_list-5').slick({
                arrows: true,
                dots: true,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                            centerMode: true,
                            infinite: true
                        }
                    }
                ]
            });

            $('#product_list-6').slick({
                arrows: true,
                dots: true,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                            centerMode: true,
                            infinite: true
                        }
                    }
                ]
            });
        }
    });



    $('#product_list, #product_list-2, #product_list-3, #product_list-4, #product_list-5, #product_list-6, #product_list-7, #product_list-8, #product_list-9, #product_list-10, #product_list-11').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#carrousel-banner-categories').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    speed: 1000,
                }
            }
        ]
    });

    
    $('.categorias__list').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 1000,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                }
            }
        ]
    });

    $('.banner-elas-usam__list').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        responsive: [
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });

    $('.product-ratings__list').slick({
        arrows: true,
        dots: true,
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        appendArrows: $('.ratingsArrows'),
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });


    


})